<template>
  <v-app>
    <v-app-bar dense dark app hide-on-scroll extension-height="48px">
      <v-img alt="SalaryCapMadness" class="shrink mr-2" contain src="./assets/scmad2.png" transition="scale-transition" width="40"/>

      <h1 class="shrink hidden-sm-and-down logo">
        <span class="primary--text">$alaryCap</span><span class="accent--text font-italic">Madness</span>
      </h1>
      
      <v-spacer></v-spacer>

      <v-btn small v-if="user" text @click="logOut">
        <span class="mr-2">{{user.firstName}}</span>
        <v-icon>mdi-logout</v-icon>
      </v-btn>
      <v-btn small v-else text to="/login">
        <span class="mr-2">Log In</span>
        <v-icon>mdi-login</v-icon>
      </v-btn>

      <template v-slot:extension class="py-0 grey darken-2 ">
        <v-btn-toggle group class="hidden-md-and-up">
          <v-btn min-width="30px" tile text color="grey" active-class="nav" to="/"><v-icon>mdi-home</v-icon></v-btn>
          <v-btn min-width="30px" tile text color="grey" active-class="nav" to="/rules"><v-icon>mdi-information-outline</v-icon></v-btn>
          <v-btn v-if="user" min-width="30px" tile text color="grey" active-class="nav" to="/mypicks"><v-icon>mdi-checkbox-marked-outline</v-icon></v-btn>
          <v-btn min-width="30px" tile text color="grey" active-class="nav" to="/leaders"><v-icon>mdi-format-list-numbered</v-icon></v-btn>
          <v-btn v-if="isAdmin()" min-width="30px" tile text color="grey" active-class="nav" to="/admin"><v-icon>mdi-cog</v-icon></v-btn>
        </v-btn-toggle>
        <v-btn-toggle group class="hidden-sm-and-down">
          <v-btn tile text color="grey" active-class="nav" to="/"><v-icon>mdi-home</v-icon> Home</v-btn>
          <v-btn tile text color="grey" active-class="nav" to="/rules"><v-icon>mdi-information-outline</v-icon> Rules</v-btn>
          <v-btn v-if="user" tile text color="grey" active-class="nav" to="/mypicks"><v-icon>mdi-checkbox-marked-outline</v-icon> My Picks</v-btn>
          <v-btn tile text color="grey" active-class="nav" to="/leaders"><v-icon>mdi-format-list-numbered</v-icon> Leaderboard</v-btn>
          <v-btn v-if="isAdmin()" min-width="30px" tile text color="grey" active-class="nav" to="/admin"><v-icon>mdi-cog</v-icon> Admin</v-btn>
        </v-btn-toggle>
      </template>
    </v-app-bar>

    <v-content>
      <v-container>
        <v-slide-x-transition leave-absolute>
          <router-view/>
        </v-slide-x-transition>
      </v-container>

      <v-snackbar top app :timeout="timeout" v-model="snackbar">
        {{ snackbar }}
        <v-btn color="red" text @click="clearSnack">
          Close
        </v-btn>
      </v-snackbar>

      <v-btn absolute right bottom dark rounded fixed color="primary" class="ma-4" v-if="isPickable()" to="/makeentry">
        <v-icon class="mr-2">mdi-checkbox-marked-outline</v-icon>New Entry
      </v-btn>
    </v-content>

    

      
    <!-- </v-content> -->
  </v-app>
</template>

<script>
import { fa } from '@/db'
import _ from 'lodash'

export default {
  name: 'App',

  components: {
    // HelloWorld,
  },

  data() {
    return {
      timeout: 0
    }
  },
  computed: {
    snackbar: {
      get() {
        return this.$store.getters.snackbar
      },
      set() {
        //this.$store.dispatch('clearSnack')
      }
    },
    user() {
      return this.$store.getters.user
    },
    status() {
      return this.$store.getters.status
    },
    picksByUser() {
      return _.groupBy(this.$store.getters.picks, 'uid')
    },
    numberOfUserPicks() {
      return (this.picksByUser[fa.currentUser.uid]) ? this.picksByUser[fa.currentUser.uid].length : 0
    }
  },
  methods: {
    isPickable() {
      let notMakeEntry = (this.$router.currentRoute.path == '/makeentry') ? false : true
      return (this.user && this.numberOfUserPicks < 3 && notMakeEntry && this.status < 1) ? true : false
    },
    isAdmin() {
      return (this.user) ? this.user.admin : false
    },
    clearSnack() {
      this.$store.dispatch('clearSnack')
    },
    logOut() {
      fa.signOut().then(() => {
        this.$router.push("/")
      })
    }
  }
};
</script>

<style>
  .top-nav { position: fixed;}
  .logo { font-family: 'Candal'; letter-spacing: -2px; }
  .logo-small { font-family: 'Candal'; letter-spacing: -1px; }
  .nav { border-bottom: 2px solid #33cc33 !important; }
  .page { min-width: 400px; max-width: 500px; margin-left: auto;}
  .page-container {margin-top: 84px;}
  .slide-enter-active {
    transition: all .6s ease-in;
  }
  .slide-leave-active {
    transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-enter, .slide-leave-to {
    transform: translateX(100px);
    opacity: 0;
  }
</style>
